import fetchData from 'isomorphic-unfetch'
const getData = ({
    url,
    method = "GET",
    headers,
    params,
    html,
    contentType
}) => {
    if (method === "GET") {
        return fetchData(url, {
            method,
            headers,
        }).then((resp) => html ? resp.text() :resp.json())
            .then(result => {
                return result;
            })
    }
    else {
        var formBody = void 0;
        if (contentType === "json") {
            formBody = JSON.stringify(params);
            headers["Content-Type"] = "application/json"
        }
        if (contentType === "formData") {
            formBody = new FormData();
            for (let key in params) {
                if (Array.isArray(params[key])) {
                    formBody.append(key, JSON.stringify(params[key]));
                }
                else {
                    formBody.append(key, params[key]);
                }
            }
            headers["Content-Type"] = "multipart/form-data"
        }
        if (contentType === "urlencoded") {
            formBody = [];
            for (var property in params) {
                var encodedKey = encodeURIComponent(property);
                var encodedValue = encodeURIComponent(params[property]);
                formBody.push(encodedKey + "=" + encodedValue);
            }
            formBody = formBody.join("&");
            headers["Content-Type"] = "application/x-www-form-urlencoded";
        }
        return fetchData(url, {
            method: 'POST',
            body: formBody,
            headers: {
                ...headers,
                "Cache-Control": "no-cache",

            }
        }).then((resp) => resp.json())
            .then(result => {
                return result;
            })
    }
}

export {
    getData
}